<script>
import AiAssistantItem from "./ai-assistant-item.vue";
import { api } from './ai-assistant-api';
import Typed from "@/app/admin/system/ai/aitype.vue";

export default {
  
  props : {
    contentType: {
      type: String,
      required: true
    },
    onEnd: {
      type: Function,
      default: null
    },
    jsonData: {}
  },
  watch: {
    contentType(newValue, oldValue) {
      // 在这里处理props值变化的逻辑
      console.log('contentType changed from', oldValue, 'to', newValue);
      this.isNew = false;
      this.aiData = "";
      // 调用接口获取
      this.generate();
    }
  },
  data() {
    return {
      avatarPath: require('@/assets/ai-assistant-avatar.png'),
      copyIconPath: require('@/assets/ai-assistant_copy.png'),
      closeImagePath: require('@/assets/icon_close.png'), // 这里的路径需要根据实际的目录结构和图片文件名来设置
      aiData : "",
      isNew: false,
      removeGradient: false,
      generated: -1, // 1 生成中状态 , -1 未生成状态
    };
  },

  components: {
    AiAssistantItem,
    Typed
  },
  mounted() {
    this.generate();
    this.$nextTick(() => {
      const content = this.$refs.aiAssscrollContainer;
      if (content){
        content.addEventListener('scroll', this.handleScroll);
      }

    });
  },
  beforeUnmount() {
    const content = this.$refs.aiAssscrollContainer;
   if (content){
     content.removeEventListener('scroll', this.handleScroll);
   }
  },
  methods: {
    handleResize() {
      //console.log("bottomScrollClick")
      this.$nextTick(() => {
        let scrollEl = this.$refs.mainscroll;
        if(scrollEl)
          scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior: 'smooth' });
    })},
    copyText(){
      let ref = this.$refs.typeref;
      if(ref){
        return ref.getText();
      }
      return "";
      
    },
    copySuccess(){
      this.$message.info("复制成功！");
    },
    onError(){
      this.$message.info("复制失败！");
    },
    onMsgEnd(){
      this.generated = 1;
      console.log("onMsgEnd");
    },
    handleScroll() {
      const content = this.$refs.aiAssscrollContainer;
      if (content){
        // 判断是否滚动到底部
        if (content.scrollTop + content.clientHeight >= content.scrollHeight) {
          // 执行滚动到底部后的逻辑
          console.log("已滚动到底部");
          this.removeGradient = true;
        }else{
          this.removeGradient = false;
        }
      }
    },
    filling(){
      this.generated = -1;
      let ref = this.$refs.typeref;
      if(ref){
        this.$emit('filling',ref.getText());
      }
    },
    
    // 关闭弹窗
    closeAct(){
      this.generated = -1;
      this.$emit('close');
    },
    reCreate(){
      console.log("调用重新生成....");
      // this.isNew = true;
      this.aiData = "";
      let ref = this.$refs.typeref;
      if(ref){
        ref.restart([this.aiData]);
        this.generate();
      }
      // this.init();

      // window.location.reload();
    },
    async generate(){
      this.generated = -1;
      let objData = {};
      console.log("objData: ");
      console.log(this.jsonData);
      if (this.jsonData){
        objData = Object.fromEntries(this.jsonData);
      }

      let that = this;
      let params = {};
      params.data = objData;
      params.contentType = this.contentType;

      api.generate(this.contentType, params, function(conversation,finish,msg){
          let ref = that.$refs.typeref;
          // let ref = that.$refs.typeref[that.$refs.typeref.length-1] // DOM
          if(finish) {
            console.log("finish");
            if(ref){
              ref.setEnd(true);
            }
            console.log('end')
          }
          if(!finish) {
            // ref.restart([self.aiData]);
            console.log("doing");
            if(ref){
              ref.addMsg(msg);
            }
            that.aiData+=msg;
          }        
        });
    },
  }
};
</script>

<template>
<div class ="ai-assistant-content">
<!-- 顶部 -->
  <div class = "ai-assistant-nav">AI小助手</div>
  <div class = "ai-assistant-close" @click.stop="closeAct()">
    <img class = "ai-assistant-close-image" :src="closeImagePath" alt="closeImage" />
  </div>
<!--  分割线-->
  <div class = "ai-assistant-line-view"></div>

  <div class="aiAssscrollContainer" @scroll="handleScroll" ref="mainscroll">
    <!-- <AiAssistantItem v-if = "this.isNew == false" :message="contentType === '1' ? '正在根据信息智能生成[工作内容]…' : contentType === '2' ? '正在根据信息智能生成[任职要求]…' : '正在根据信息智能生成[工作内容]…'" /> -->
    <!-- <AiAssistantItem :show-copy-button = "true" v-if = "this.aiData != null" :message = "this.aiData.msg"/> -->
    <div class="ai-assistant-row-content">
      <!--头像-->
      <div class="col ai-assistant-fixed-col-avatar">
        <div class="ai-assistant-item-avatar-bg">
          <img class="ai-assistant-avatar-image" :src="avatarPath" alt="avatarImage" />
        </div>
      </div>
      <!--内容-->
      <div class = "ai-assistant-message-content" v-resize="handleResize">
        <Typed ref="typeref" :typedList=[this.aiData] :onEnd="onMsgEnd"></Typed>
      </div>
     
      <!--拷贝 -->
      <div class="ai-assistant-message-copy"
           v-if = "generated == 1"
           @click = "copyText"
           v-clipboard:copy="this.aiData"
           v-clipboard:success="copySuccess"
           v-clipboard:error="onError">
        <img class="ai-assistant-copy-image" :src="copyIconPath" alt="copyImage" />
      </div>
    </div>
    
    
    <div style="height:10px"></div>
  </div>
  <!--  白色渐变-->
  <div class = "ai-assistant-white-gradient" v-if = "removeGradient == false && generated == 1"></div>
  <!--  重新生成按钮-->
  <button v-if = "generated == 1" class="ai-assistant-button ai-assistant-button-text" @click = "reCreate()">重新生成</button>
  <button v-if = "generated == 1" class="ai-write-button ai-assistant-white-button-text" @click = "filling()">一键填入</button>
</div>
</template>

<style scoped lang="scss">
.ai-assistant-content{
  background: #FFFFFF;
  border-radius: 6px;
  height:480px;
  width:500px;
}
.ai-assistant-nav{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 52px;

  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0,0,0,0.75);
  line-height: 22px;
}
.ai-assistant-close{
  width: 48px;
  height: 48px;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
}
.ai-assistant-close-image{
  width: 16px;
  height: 16px;
}
.ai-assistant-line-view{
  margin: 0px 13px 0px 13px;
  background-color: #0000001A;
  height: 1px;
}
.ai-assistant-button-text{
  font-weight: 500;
  color: #7788FF;
  line-height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  z-index: 999999;
}

.ai-assistant-white-gradient{
  width: 100%;
  position: absolute;
  bottom: 60px;
  height: 60px;
  background: linear-gradient(360deg, #FFFFFF 0%, rgba(255,255,255,0) 100%);
  border-radius: 6px;
}
.ai-assistant-button{
  left: 70px;
  background-color: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #7788FFFF;
  position: absolute;
  bottom: 20px;
  width: 35%;
  height: 40px;
}
.ai-write-button{
  // margin: 0px 88px 0px 88px;
  right: 70px;
  // background-color: #FFFFFF;
  border-radius: 4px;
  background-color: #7788FFFF;
  border: 1px solid #7788FFFF;
  position: absolute;
  bottom: 20px;
  width: 35%;
  height: 40px;
}
.ai-assistant-white-button-text{
  font-weight: 500;
  color: white;
  line-height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  z-index: 999999;
}
.aiAssscrollContainer{
  height: 365px; /* 设置容器的固定高度，超出部分将会滚动 */
  overflow-y: auto; /* 设置垂直溢出时显示滚动条 */
  padding-right: 16px; /* 适应滚动条的宽度 */
  //overflow: hidden; /* 隐藏indicate */
}
/* 隐藏滚动条但保留滚动行为 */
.aiAssscrollContainer::-webkit-scrollbar {
  width: 0.1em;
  background-color: transparent;
}

.aiAssscrollContainer::-webkit-scrollbar-thumb {
  background-color: transparent;
}

.ai-assistant-row-content {
  display: flex;
  justify-content: left;
  margin: 15px;
  //align-items: flex-start;
}

.col {
  flex: 1;
}

.ai-assistant-fixed-col-avatar{
  flex: 0 0 50px;
}

.ai-assistant-item-avatar-bg {
  flex: 0 0 24px;
  width: 40px;
  height: 40px;
  background: #edf6fd;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ai-assistant-message-content{
  background: rgba(0,0,0,0.05);
  border-radius: 4px;
  padding: 12px;
  max-width: 80%;
  white-space: pre-line;
  word-wrap: break-word;
  overflow-wrap: break-word; /* 添加这行样式，以便支持旧版本浏览器 */
}

.ai-assistant-avatar-image {
  width: 24px;
  height: 24px;
}
.ai-assistant-copy-image img {
  width: 12px;
  height: 12px;
}
.ai-assistant-message-copy{
  width: 24px;
  height: 24px;
  background-size: 12px;
  margin-left: 4px;
  background-color: #7788FFFF;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>